import React from 'react';
import { Stack } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import './LineItemProductDetails.scss';

type Props = {
  item: LineItem;
};

export const LineItemProductDetails: React.FC<Props> = ({
  item: {
    attributes: { designerName, productName, color }
  }
}) => {
  return (
    <Stack space={2}>
      <div className="LineItemProductDetails__designer">{designerName}</div>
      <div>{productName}</div>
      <div className="LineItemProductDetails__color">Color: {color}</div>
    </Stack>
  );
};
